// Mock data for frontend-only implementation

export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({ success: true, message: 'Inquiry submitted successfully!' });
    }, 1000);
  });
};

export const heroImage = 'https://images.unsplash.com/photo-1613690399151-65ea69478674?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxjb250YWluZXIlMjBzaGlwJTIwb2NlYW58ZW58MHx8fHwxNzgzNTkyMjM3fDA&ixlib=rb-4.1.0&q=85';

export const serviceImages = {
  ocean: 'https://images.unsplash.com/photo-1605732562742-3023a888e56e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMGNvbnRhaW5lcnN8ZW58MHx8fHwxNzgzNTkyMjY3fDA&ixlib=rb-4.1.0&q=85',
  sourcing: 'https://images.unsplash.com/photo-1597334948330-38795f25d05d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxwb3J0fGVufDB8fHx8MTc4MzU5MjI2Nnww&ixlib=rb-4.1.0&q=85',
  customs: 'https://images.unsplash.com/photo-1562892302-97faedd66f1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxwb3J0fGVufDB8fHx8MTc4MzU5MjI2Nnww&ixlib=rb-4.1.0&q=85'
};

export const galleryImages = [
  'https://images.unsplash.com/photo-1606185540834-d6e7483ee1a4',
  'https://images.unsplash.com/photo-1578575437130-527eed3abbec',
  'https://images.unsplash.com/photo-1670121180530-cfcba4438038',
  'https://images.unsplash.com/photo-1605745341112-85968b19335b'
];